import { Typography } from "@mui/material";
import CustomConfirmDialog from "../../../core/components/common/custom-confirm-dialog.component";
import { useState } from "react";
import CustomLoader from "../../../core/components/common/custom-loader.component";
import { useSnackbar } from 'notistack';
import ModuleService from "../services/api/module-service";

const DeleteModuleModal = ({module, open, setOpen, handleRecordChange}) => {

    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const handleClose = () => setOpen(false);
    const handleConfirm = () => {

        setLoading(true);

        let parameters = {
            'id': module.id
        }

        ModuleService.deleteModule(parameters).then((res) => {
            setLoading(false);
            setOpen(false)
            handleRecordChange()
            enqueueSnackbar("Module was successfully deleted", {
                variant: "success",
                autoHideDuration: 1500
            })
        }).catch((error) => {
            setLoading(false);
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
        })
    }
    
    return (
        <CustomConfirmDialog
        loading={loading}
        open={open}
        handleClose={handleClose}
        handleConfirm={handleConfirm} 
        title={'Delete Module'}
        >
        <div>
            {loading ? (
                <CustomLoader />
            ):(
                <Typography>Are you sure you want to delete this module?</Typography>
            )}
        </div>
      
        </CustomConfirmDialog>
    )
}

export default DeleteModuleModal